/**
 * hook: useMrcAuth()
 *
 * Middleware that allows components to connect to Authentication library.
 */

import { useEffect, useState } from 'react';

import {auth} from '@artegeie/mona-sdk/auth';

import { onLogin, onLogout } from '@artegeie/mona-sdk/auth'

import useRouter from 'Hooks/useRouter';

export default () => {


	const [ loginState, setLoginState ] = useState( false );
	const [ loginURL, setLoginURL ] = useState( '' );
	const [ token, setToken ] = useState(null);

	const { buildPath } = useRouter();

	useEffect(() => {
		onLogin((detail ) => {

			setLoginState( true );
			setToken( auth.authInstance.tokens.access );
			setLoginURL( buildPath('account_profile', {} ) );
		});

		onLogout((detail) => {

			setLoginState( false );
			setToken( null );
			setLoginURL( buildPath('account_login', {} ) );
		});

	} );

	return {
		loginState,
		loginURL,
		token
	};
};
